import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../data-access/auth.service';

/**
 * Guard for routes that require email verification.
 * This guard is self-contained and checks both authentication and email verification.
 *
 * - If NOT authenticated → redirect to login
 * - If authenticated AND email verified → allow access (return true)
 * - If authenticated BUT email NOT verified → redirect to verify page
 */
export const emailVerifiedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastrService);

  // First check if user is authenticated
  if (!authService.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  // Then check if email is verified
  if (authService.isEmailVerified()) {
    return true;
  }

  // User is authenticated but email is not verified
  const user = authService.getStoredUser();
  const email = user?.email ?? '';
  toast.warning('Please verify your email to continue.', 'Email not verified');
  router.navigate(['/auth/verify'], { queryParams: { email } });
  return false;
};

